// const addInfo = {
//   title: 'KPIDashboard',
//   icon: 'dashboard'
// }
const KPIRouter = {
  path: '/kpi',
  meta: {
    title: 'KPIDashboard',
    icon: 'dashboard',
    permission: ['kpi_dashboard']
  },
  children: [
    {
      path: 'kpi-dashboard',
      component: () => import('@/views/KPIDashboard/kpi-dashboard'),
      name: 'KPIDashboard',
      meta: { title: 'KPIDashboard', parent: { title: 'KPIDashboard', icon: 'dashboard'}, permission: ['kpi_dashboard'] }
    }
    // {
    //   path: 'driver-details/:id',
    //   component: () => import('@/views/driver/ManageDriver/driver-details'),
    //   name: 'DriverDetails',
    //   hidden: true,
    //   meta: { title: 'DriverDetails', parent: addInfo, activeMenu: '/driver/manage-driver', enableBack: true, backPage: 'ManageDriver' }
    // },
  ]
}

export default KPIRouter
